<template>
  <div class="param px">
    <div class="param-item">
      <div class="name">{{ $t("dongle.switch") }}</div>
      <md-switch class="md-primary" v-model="lightEnabled"></md-switch>
    </div>
    <template v-if="lightEnabled">
    <div class="param-item" v-if="false">
      <div class="name">{{ $t("mouse.effect") }}</div>
      <md-field class="field">
        <md-select v-model="internalLigthType" class="select">
          <md-option
            v-for="(value, index) in ['Solid', 'Breathing', 'Neon']"
            :value="value"
            :key="'key' + index"
          >
            {{ $t(`mouse.effects[${index + 1}]`) }}
          </md-option>
        </md-select>
      </md-field>
    </div>
    <div class="param-item" v-show="ligthType !== 'Solid'">
      <div class="name">{{ $t("mouse.speed") }}</div>
      <div class="control-container">
        {{ $t("slow") }}
        <a-slider
          class="slider"
          :value="Number(mouseLightSpeed)"
          @change="onLigthSpeedChange"
          :min="1"
          :max="10"
          :tooltipVisible="false"
        />
        {{ $t("fast") }}
      </div>
    </div>
    <div class="param-item">
      <div class="name">{{ $t("mouse.color") }}</div>
      <div class="colors">
        <a-tooltip
          placement="top"
          v-for="(color, index) in lightRGB"
          :key="index"
          overlayClassName="picker-tooltip"
        >
          <template slot="title">
            <sketch-picker
              class="picker"
              :value="color"
              disableAlpha
              @input="onLigthRGBChange(index, $event)"
              :preset-colors="[
                '#D0021B',
                '#F5A623',
                '#F8E71C',
                '#8B572A',
                '#7ED321',
                '#417505',
                '#BD10E0',
                '#9013FE',
                '#4A90E2',
                '#50E3C2',
                '#B8E986',
                '#000000',
                '#444444',
                '#888888',
                '#CCCCCC',
                '#FFFFFF',
              ]"
            />
          </template>

          <div class="color" :style="{ backgroundColor: color }">
            <i
              v-if="lightRGB.length > 2"
              class="color-remove iconfont iconclose"
              @click="onColorRemove(index)"
            />
          </div>
        </a-tooltip>
        <i
          v-if="ligthType !== 'Solid' && lightRGB.length < 7"
          class="color-add iconfont iconplus-o"
          @click="onColorAdd"
        />
      </div>
    </div></template>
  </div>
</template>
<script>
import { mapState } from "vuex";
import vueColor from "vue-color";

export default {
  name: "CMouseAm35Light",
  components: {
    "sketch-picker": vueColor.Sketch,
  },
  data() {
    return {
      timer: 0, // 添加定时器用于防抖
    };
  },
  beforeDestroy() {
    // 组件销毁前清理定时器，避免内存泄漏
    if (this.timer) {
      clearTimeout(this.timer);
      // 离开页面时如果有未保存的操作，立即保存一次
      this.$store.dispatch("loader/setAM35light", this.getLightData());
    }
  },
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState("app", {
      isCN: "isCN",
    }),
    ...mapState("mouseAM35", {
      // 从 lightData 对象中获取所有灯效相关属性
      mouseLightSwitch: (state) => (state.lightData && state.lightData.mouseLightSwitch) || "1",
      mouseLightType: (state) => (state.lightData && state.lightData.mouseLightType) || "",
      // 确保 mouseLightSpeed 返回 Number 类型
      mouseLightSpeed: (state) => {
        const speed = state.lightData && state.lightData.mouseLightSpeed;
        return speed ? Number(speed) : 1;
      },
      mouseLightRGB: (state) => (state.lightData && state.lightData.mouseLightRGB) || ["00FF00"],
    }),
    internalLigthType: {
      get() {
        return this.mouseLightType || "Solid";
      },
      set(value) {
        this.onLigthTypeChange({ target: { value } });
      },
    },
    // 转发其他lightData属性以兼容现有代码
    ligthType() {
      return this.mouseLightType || "Solid";
    },
    lightSpeed() {
      return Number(this.mouseLightSpeed ?? 1);
    },
    lightRGB() {
      return this.mouseLightRGB || ["#00FF00"];
    },
    // 添加 lightEnabled 计算属性，与 mouseLightSwitch 双向绑定
    lightEnabled: {
      get() {
        return this.mouseLightSwitch === "1";
      },
      set(value) {
        this.onLightEnabledChange(value);
      },
    },
  },
  methods: {
    // 获取当前完整的 lightData
    getLightData() {
      return {
        mouseLightSwitch: this.mouseLightSwitch,
        mouseLightType: this.mouseLightType || "Solid", // 灯效类型默认为 "Solid"
        mouseLightSpeed: Math.max(1, Number(this.mouseLightSpeed ?? 1)), // 速度最小值为1
        mouseLightRGB: this.mouseLightRGB || ["#00FF00"],
      };
    },
    onLightEnabledChange(value) {
      // 如果开关状态改变，立即保存
      const lightData = {
        ...this.getLightData(),
        mouseLightSwitch: value ? "1" : "0",
      };

      this.$store.dispatch("loader/setAM35light", {
        mouseLightSwitch: lightData.mouseLightSwitch,
        mouseLightType: lightData.mouseLightType,
        mouseLightSpeed: lightData.mouseLightSpeed,
      });
      this.$store.commit("mouseAM35/SET_LIGHT_DATA", lightData);
    },
    onLigthTypeChange(e) {
      let newLightRGB = [...(this.mouseLightRGB || ["#00FF00"])];
      if (e.target.value === "Solid") {
        newLightRGB = [newLightRGB[0]];
      } else if (this.mouseLightType === "Solid") {
        newLightRGB[1] =
          "#" +
          Math.floor(Math.random() * 0x1000000)
            .toString(16)
            .padStart(6, "0");
      }

      const lightData = {
        mouseLightSwitch: this.mouseLightSwitch,
        mouseLightType: e.target.value,
        mouseLightSpeed: this.mouseLightSpeed,
        mouseLightRGB: newLightRGB,
      };

      // 只设置灯效类型和其他参数，不设置RGB
      this.$store.dispatch("loader/setAM35light", {
        mouseLightSwitch: lightData.mouseLightSwitch,
        mouseLightType: lightData.mouseLightType,
        mouseLightSpeed: lightData.mouseLightSpeed,
      });

      this.$store.commit("mouseAM35/SET_LIGHT_DATA", lightData);
    },
    onLigthSpeedChange(e) {
      // 使用 requestAnimationFrame 优化渲染
      window.requestAnimationFrame(() => {
        const lightData = {
          ...this.getLightData(),
          mouseLightSpeed: e, // e 本身已经是 Number 类型
        };

        // 立即更新 store 状态，保持滑动条响应
        this.$store.commit("mouseAM35/SET_LIGHT_DATA", lightData);

        // 使用防抖延迟保存到设备
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
          this.$store.dispatch("loader/setAM35light", {
            mouseLightSwitch: lightData.mouseLightSwitch,
            mouseLightType: lightData.mouseLightType,
            mouseLightSpeed: lightData.mouseLightSpeed,
          });
        }, 500); // 500ms 防抖延迟
      });
    },
    onColorRemove(index) {
      let newLightRGB = [...(this.mouseLightRGB || ["#00FF00"])];
      newLightRGB.splice(index, 1);

      const lightData = {
        ...this.getLightData(),
        mouseLightRGB: newLightRGB,
      };

      // 移除颜色时只调用RGB设置
      this.$store.dispatch("loader/setAM35lightRGB", {
        mouseLightRGB: lightData.mouseLightRGB,
      });
      this.$store.commit("mouseAM35/SET_LIGHT_DATA", lightData);
    },
    onColorAdd() {
      let newLightRGB = [...(this.mouseLightRGB || ["#00FF00"])];
      newLightRGB.push(
        "#" +
          Math.floor(Math.random() * 0x1000000)
            .toString(16)
            .padStart(6, "0")
      );

      const lightData = {
        ...this.getLightData(),
        mouseLightRGB: newLightRGB,
      };

      // 添加颜色时只调用RGB设置
      this.$store.dispatch("loader/setAM35lightRGB", {
        mouseLightRGB: lightData.mouseLightRGB,
      });
      this.$store.commit("mouseAM35/SET_LIGHT_DATA", lightData);
    },
    onLigthRGBChange(index, e) {
      window.requestAnimationFrame(() => {
        // 直接在 map 中更新颜色值
        const newLightRGB = (this.mouseLightRGB || ["#00FF00"]).map((c, i) => {
          if (i === index) {
            const color = e.hex ? e.hex : "#" + e.target.value;
            return color.length === 7 ? color : "#000000";
          }
          return c;
        });

        const lightData = {
          mouseLightSwitch: this.mouseLightSwitch,
          mouseLightType: this.mouseLightType || "Solid",
          mouseLightSpeed: Number(this.mouseLightSpeed ?? 1),
          mouseLightRGB: newLightRGB,
        };

        // 立即更新 store 状态
        this.$store.commit("mouseAM35/SET_LIGHT_DATA", lightData);

        if (this.timer) {
          clearTimeout(this.timer);
        }

        // 使用防抖延迟保存到设备
        this.timer = setTimeout(() => {
          this.$store.dispatch("loader/setAM35lightRGB", {
            mouseLightRGB: newLightRGB,
          });
        }, 500); // 500ms 防抖延迟
      });
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.param {
  font-size: 16px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%; /* 添加100%宽度 */

  .title {
    width: 100%; /* 改为100%宽度 */
    text-align: left;
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .param-item {
    @include flex-center;
    width: 100%; /* 改为100%宽度，不再使用固定宽度 */
    justify-content: flex-start;
    padding: 0 0;
    height: 0.55rem;
    .name {
      min-width: 1.2rem;
    }
    .control-container {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .slider {
      width: 300px;
      margin: 0 20px;
    }

    .radio-group {
      @include flex-center;

      .radio {
        @include flex-center;
        height: 50px;
        line-height: 50px;
        margin-right: 5px;
      }
    }

    .colors {
      @include flex-center;

      .color {
        width: 30px;
        height: 30px;
        border: 1px solid $primary-color;
        border-radius: 8px;
        position: relative;
        margin-right: 20px;
        cursor: pointer;

        .color-remove {
          @include flex-center;
          display: none;
          width: 25px;
          height: 25px;
          border-radius: 25px;
          background: $primary-color;
          color: #ffffff;
          position: absolute;
          right: -8px;
          top: -8px;
          cursor: pointer;
        }

        &:hover .color-remove {
          display: flex;
        }
      }

      .color-add {
        color: $primary-color;
        font-size: 32px;
        margin-left: 2px;
        cursor: pointer;
      }
    }

    .num,
    .tip {
      width: 80px;
      font-size: 20px;
      margin: 0 40px 0 0;
      padding: 0;
      white-space: nowrap;

      .number-input {
        width: 100%;
        text-align: center;
      }
    }

    .tip {
      width: auto;
      font-size: 16px;
      color: #cccccc;
    }
  }

  .button {
    @include button;
    width: 120px;
    height: 34px;
    border: 1px solid $primary-color;
    border-radius: 5px;
    background: transparent;
    color: $primary-color;

    &:hover {
      color: #ffffff;
    }
  }
}
</style>

<style lang="scss">
.param {
  .slider {
    padding: 4px 0;
    .ant-slider-rail {
      height: 4px;
      background-color: #717171 !important;
    }

    .ant-slider-track {
      height: 4px;
      background-color: $primary-color !important;
    }

    .ant-slider-step {
      height: 4px;
    }

    .ant-slider-handle {
      width: 20px;
      height: 20px;
      margin-top: -7px;
      background-color: $primary-color !important;
      border: 0;
      box-shadow: none;
    }
  }

  .ant-radio-group .radio {
    background: #101010;
    border-radius: 5px;
    padding: 0 2px 0 12px;
    margin-right: 12px;

    .ant-radio {
      margin-right: 5px;

      .ant-radio-inner {
        border-color: $primary-color;

        &::after {
          background-color: $primary-color;
        }
      }
    }

    &.ant-radio-wrapper-checked,
    &:hover {
      color: $primary-color;
    }
  }

  .color-slider {
    .vc-slider-hue-warp {
      height: 10px;

      .vc-hue-pointer {
        margin-top: -5px;
      }
    }
  }
}

.ant-tooltip-inner {
  color: #000000;

  .vc-editable-input input {
    text-align: center;
  }
}

.picker-tooltip .ant-tooltip-inner {
  padding: 0;
}
</style>
